import CircularProgress from "@mui/material/CircularProgress";
import { forwardRef } from "react";

const CustomCircularProgress = forwardRef(({ color = "#2b233d", ...rest }, ref) => {
  return <CircularProgress ref={ref} style={{ color }} {...rest} />;
});

export default CustomCircularProgress;
